import React from 'react';

import styles from './PickupPointList.module.css'
import {PickupPointItem} from "./PickupPointItem/PickupPointItem.tsx";
import {PickupPoint} from "./PickupPointItem/types/PickupPoint.interface.ts";
import {PickupPointTransportCompanyDeliveryItem} from "./PickupPointItem/PickupPointTransportCompanyDeliveryItem.tsx";

interface Props {
    currentTownId: number|null,
    pickupPoints: PickupPoint[],
    choosePickPoint: (point: PickupPoint) => void,
    changeCheckedPickPoint: (point: PickupPoint) => void,
}

export const PickupPointList: React.FC<Props> = ({
                                                     changeCheckedPickPoint,
                                                     choosePickPoint,
                                                     currentTownId,
                                                     pickupPoints,
                                                 }) => {
    const points = pickupPoints.filter(point => {
        return point.townId === currentTownId;
    })
    return (
        <ul className={styles.list} style={{backgroundColor: '#fafafa'}}>
            {
                points.length === 0 || currentTownId !== 1
                ? <li style={{padding: 12,}}>
                        <PickupPointTransportCompanyDeliveryItem />
                    </li>
                : null
            }
            {points.map((point) => {
                    return (<li key={point.id} style={{padding: 12,}}>
                            <PickupPointItem
                                point={point}
                                choosePickPoint={choosePickPoint}
                                currentTownId={currentTownId}
                                changeCheckedPickPoint={changeCheckedPickPoint}
                            />
                        </li>
                    )
                }
            )}
        </ ul>
    );
};